<template>
  <section class="info">
    <div class="app-container">
      <h2 class="info__judul">Informasi Kegiatan</h2>

      <!-- Ringkasan: satu baris kartu ringkas, tinggi seragam. -->
      <div class="info__ringkas">
        <div v-if="tournament.location" class="info__kartu">
          <span class="info__ikon"><i class="bi bi-geo-alt-fill" aria-hidden="true"></i></span>
          <div>
            <span class="info__label">Lokasi</span>
            <span class="info__nilai" v-html="tournament.location"></span>
          </div>
        </div>
        <div v-if="tournament.event_date" class="info__kartu">
          <span class="info__ikon"><i class="bi bi-calendar-event-fill" aria-hidden="true"></i></span>
          <div>
            <span class="info__label">Tanggal Pertandingan</span>
            <span class="info__nilai">{{ tournament.event_date }}</span>
          </div>
        </div>
        <div v-if="usia.length" class="info__kartu">
          <span class="info__ikon"><i class="bi bi-people-fill" aria-hidden="true"></i></span>
          <div>
            <span class="info__label">Kelompok Usia</span>
            <span class="info__chips">
              <span v-for="u in usia" :key="u" class="info__chip">{{ u }}</span>
            </span>
          </div>
        </div>
      </div>

      <!-- Kategori: dikelompokkan per tingkat, urutan nomor sama dengan tabel biaya. -->
      <div v-if="kelompok.length" class="info__kategori">
        <span class="info__label info__label--blok">Kategori Pertandingan</span>
        <div class="info__grup-grid">
          <div v-for="g in kelompok" :key="g.judul" class="info__grup">
            <span v-if="kelompok.length > 1" class="info__grup-judul">{{ g.judul }}</span>
            <span class="info__chips">
              <span v-for="k in g.isi" :key="k.id || k.nama" class="info__chip">{{ k.nama }}</span>
            </span>
          </div>
        </div>
      </div>
      <!--
        Biaya pendaftaran & narahubung tidak ditampilkan di sini:
        sudah ada seksi tersendiri di halaman detail.
      -->
    </div>
  </section>
</template>

<script>
import { kelompokkanPerTingkat } from '@/utils/kategoriTingkat';

export default {
  name: 'TournamentInfo',
  props: {
    tournament: {
      type: Object,
      required: true,
    },
  },
  computed: {
    usia() {
      return (this.tournament.ageCategories || [])
        .slice()
        .sort((a, b) => Number(a.min_age || 0) - Number(b.min_age || 0) || Number(a.id) - Number(b.id))
        .map((a) => a.name)
        .filter(Boolean);
    },
    kelompok() {
      return kelompokkanPerTingkat(this.tournament.matchCategories || [], this.tournament.labelTingkat);
    },
  },
};
</script>

<style scoped>
.info {
  background-color: var(--bg-base);
  padding: var(--space-8, 32px) 0;
}

.info__judul {
  font-family: var(--font-display);
  font-size: clamp(1.3rem, 4vw, 1.75rem);
  margin: 0 0 var(--space-5, 20px);
  color: var(--text-primary);
}

.info__ringkas {
  display: grid;
  gap: var(--space-3, 12px);
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 260px), 1fr));
  margin-bottom: var(--space-3, 12px);
}

.info__kartu,
.info__kategori {
  background: var(--bg-surface);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg, 12px);
  color: var(--text-primary);
}

.info__kartu {
  display: flex;
  gap: var(--space-3, 12px);
  align-items: flex-start;
  padding: var(--space-4, 16px);
}

.info__ikon {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: var(--radius-md, 8px);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--accent-subtle, rgb(235 94 40 / .12));
  color: var(--accent, #eb5e28);
}

.info__label {
  display: block;
  font-size: var(--text-xs, .75rem);
  font-weight: 700;
  letter-spacing: .05em;
  text-transform: uppercase;
  color: var(--text-muted);
  margin-bottom: 2px;
}
.info__label--blok { margin-bottom: var(--space-3, 12px); }

.info__nilai {
  display: block;
  font-weight: 600;
  font-size: var(--text-sm, .9rem);
  line-height: 1.45;
}

.info__chips { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 4px; }
.info__chip {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: var(--text-xs, .78rem);
  font-weight: 600;
  background: var(--bg-sunken);
  border: 1px solid var(--border-subtle);
  color: var(--text-primary);
  white-space: nowrap;
}

.info__kategori { padding: var(--space-4, 16px) var(--space-5, 20px); }

.info__grup-grid {
  display: grid;
  gap: var(--space-4, 16px) var(--space-6, 24px);
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 280px), 1fr));
}

.info__grup-judul {
  display: block;
  font-size: var(--text-xs, .75rem);
  font-weight: 700;
  letter-spacing: .06em;
  text-transform: uppercase;
  color: var(--text-brand);
  padding-bottom: 6px;
  margin-bottom: 4px;
  border-bottom: 1px solid var(--border-subtle);
}
</style>
